export const sources = [
	'demo',
	'dev',
	'integration',
	'sanity-checks',
	'upskilling',
	'trial',
] as const;
